import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './contexts/AppContext';
import Navigation from './components/layout/Navigation';
import Home from './pages/Home';
import GuestRegistration from './pages/GuestRegistration';
import ApprovalDashboard from './pages/ApprovalDashboard';
import ReceptionDesk from './pages/ReceptionDesk';
import TurnstileDisplay from './pages/TurnstileDisplay';
import Statistics from './pages/Statistics';
import './index.css';

function App() {
  return (
    <AppProvider>
      <Router>
        <div className="flex min-h-screen bg-secondary-50">
          <Routes>
            {/* Full screen routes without navigation */}
            <Route path="/guest-registration" element={<GuestRegistration />} />
            <Route path="/turnstile" element={<TurnstileDisplay />} />
            
            {/* Routes with navigation */}
            <Route path="/*" element={
              <>
                <Navigation />
                <div className="flex-1">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/approval" element={<ApprovalDashboard />} />
                    <Route path="/reception" element={<ReceptionDesk />} />
                    <Route path="/statistics" element={<Statistics />} />
                  </Routes>
                </div>
              </>
            } />
          </Routes>
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;
